import {
  CashOption,
  PaymentType,
  ProductType,
  SchemaTypes,
} from '@allesauto/graphql';
import { formatDateToIsoDate } from '@allesauto/utils/funcs';

import addressToAddressInput from './addressToAddressInput';

export default function shipmentToShipmentCartItemInput(
  sku: string,
  relatedCartItem: SchemaTypes.CartItem,
  savedDealerId?: string,
  dateOption?: SchemaTypes.TimeSlotOptionInput,
  destinationDealerId?: string,
  shippingAddressId?: string
): SchemaTypes.CartItemInput {
  let shipmentOptions;

  if (dateOption || destinationDealerId || shippingAddressId) {
    shipmentOptions = {
      dateOption: dateOption ?? {
        requestDate: formatDateToIsoDate(new Date()),
      },
      destinationDealerId,
      shippingAddressId,
    };
  }

  return {
    sku,
    productType: ProductType.Shipment,
    quantity: 1,
    relatedProductSku: relatedCartItem.sku,
    dealerId: savedDealerId ?? relatedCartItem.dealer.id,
    shipmentOptions,
    paymentOptions: {
      paymentType: PaymentType.CashRange,
      cashOption: CashOption.Prepayment,
    },
    billingAddress: relatedCartItem.billingAddress
      ? addressToAddressInput(relatedCartItem.billingAddress)
      : undefined,
  };
}
